import PropTypes from "prop-types"
import { usePageAssets } from "hooks/usePageAssets"
import Container from "components/ui/Container"
import Heading from "components/ui/Heading"
import SplitContainer from "components/ui/Layout/SplitContainer"

function UserManagementAndAccessControlSection({ className }) {
  const { getAsset } = usePageAssets()
  const illustration = getAsset(
    "internal-tooling-user-management-and-access-control"
  )
  return (
    <Container className={className} section>
      <SplitContainer
        className="py-10 lg:py-20 xl:py-32 2xl:py-40"
        image={illustration}
        imageClassName="mt-8 md:mt-0 max-w-2xl mx-auto"
        reversed
      >
        <Heading
          label="User Management & Access Control"
          title="Simplify security and user management"
          subtitle={
            <>
              Tightly govern who can see data through a simple interface. Preset
              uses token-based (cookieless) authentication to seamlessly verify
              users and row-level security (RLS) to define what data each user
              can view and interact with.
            </>
          }
          narrow
        />
      </SplitContainer>
    </Container>
  )
}

UserManagementAndAccessControlSection.propTypes = {
  /** Additional className(s) */
  className: PropTypes.string,
}

export default UserManagementAndAccessControlSection
